import React from 'react';
import ClassAssembly10B from 'views/ClassAssembly10B';

const ClassAssembly10BPage = () => {
    return <ClassAssembly10B />;
  };
  
  export default ClassAssembly10BPage;

  //10B